import { useRef } from "react";

const DragDropUpload = ({ onUpload }) => {
  const fileRef = useRef();

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      onUpload(e.dataTransfer.files);
    }
  };

  return (
    <div
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center bg-gray-50 hover:border-blue-500 transition"
    >
      <i className="fas fa-cloud-upload-alt text-3xl text-gray-400 mb-2"></i>

      <p className="text-sm text-gray-600">
        Drag & drop files here or{" "}
        <span className="text-blue-600 cursor-pointer underline" onClick={() => fileRef.current.click()}>
          browse
        </span>
      </p>

      <input type="file" multiple ref={fileRef} className="hidden" onChange={(e) => onUpload(e.target.files)} />
    </div>
  );
};

export default DragDropUpload;
